import { generateSolidGatePaymentIntentRequest } from './api';

// For now, we are only using the solidGatePaymentIntent state
const initialState = {
  solidGatePaymentIntentStatus: 'idle',
  solidGatePaymentIntent: {
    solidgate_data: {
      merchant_id: null,
      signature: null,
      payment_intent: null,
    },
  },
};

export default {
  state: initialState,
  mutations: {
    RESET_SOLID_GATE_PAYMENT_INTENT(state) {
      state.solidGatePaymentIntent.solidgate_data.signature = null;
      state.solidGatePaymentIntent.solidgate_data.payment_intent = null;
      state.solidGatePaymentIntent.solidgate_data.merchant_id = null;
      state.solidGatePaymentIntent.status = 'idle';
    },
    SET_SOLID_GATE_PAYMENT_INTENT_STATUS(state, status) {
      state.solidGatePaymentIntentStatus = status;
    },
    SET_SOLID_GATE_PAYMENT_INTENT(state, solidGatePaymentIntent) {
      state.solidGatePaymentIntent = solidGatePaymentIntent;
    },
    SET_ERROR(state, { error, errorMessage } = {}) {
      state.error = error;
      state.errorMessage = errorMessage;
    },
  },
  _actions: {
    resetSolidGatePaymentIntent({ commit }) {
      commit('RESET_SOLID_GATE_PAYMENT_INTENT');
    },
    async generateSolidGatePaymentIntent(
      { commit },
      { session, order, personnelId, tips, payForSelectedItems }
    ) {
      try {
        commit('SET_SOLID_GATE_PAYMENT_INTENT_STATUS', 'loading');
        const response = await generateSolidGatePaymentIntentRequest({
          session,
          order,
          personnelId,
          tips,
          payForSelectedItems,
        });
        commit('SET_SOLID_GATE_PAYMENT_INTENT', response.data);
        commit('SET_SOLID_GATE_PAYMENT_INTENT_STATUS', 'idle');
      } catch (error) {
        console.log('Error: ', error);
        commit('SET_SOLID_GATE_PAYMENT_INTENT_STATUS', 'idle');
        commit('SET_ERROR', error);
      }
    },
  },
  get actions() {
    return this._actions;
  },
  set actions(value) {
    this._actions = value;
  },
  getters: {
    paymentMethod: state => state.paymentMethod,
    solidGatePaymentIntent: state => state.solidGatePaymentIntent,
    solidGatePaymentIntentSignature: state =>
      state.solidGatePaymentIntent?.solidgate_data?.signature,
    loadingSolidGatePaymentIntent: state =>
      state.solidGatePaymentIntentStatus === 'loading',
  },
};
